// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos base para botões primários */
.btn-primary {
  /* Estrutura de layout flex */
  display: flex;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  
  /* Estilo visual */
  border-radius: 8px;
  border: 2px solid var(--color-primary-red);
  color: var(--color-primary-red);
  
  /* Tipografia */
  font-family: ShellMedium, sans-serif;
  font-weight: 500;
  text-decoration: none;
  
  /* Comportamento */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

/* Estado hover do botão */
.btn-primary:hover {
  background-color: rgba(221, 29, 32, 0.1);
}

/* Estado ativo do botão */
.btn-primary.active {
  background: var(--color-primary-red);
  color: var(--color-primary-white);
}

/* Estado ativo hover */
.btn-primary.active:hover {
  background: #c41a1d; /* Versão mais escura do vermelho primário */
}

/* Estado desabilitado */
.btn-primary:disabled,
.btn-primary.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  border-color: #999;
  color: #999;
}

/* Variação de tamanho: tiny */
.btn-primary[data-size="tiny"] {
  font-weight: 500;
  font-size: 12px;
  letter-spacing: var(--letter-spacing-disclaimer);
  height: 24px;
  padding: 0px 8px;
  vertical-align: bottom;
}

/* Variação de tamanho: small */
.btn-primary[data-size="small"] {
  font-size: 14px;
  padding: 8px 16px;
}

/* Variação de tamanho: medium (padrão) */
.btn-primary[data-size="medium"] {
  font-size: 16px;
  padding: 14px 20px;
}

/* Variação de tamanho: large */
.btn-primary[data-size="large"] {
  font-size: 18px;
  padding: 16px 24px;
}

/* Variação com ícone */
.btn-primary.with-icon {
  gap: 8px;
}

/* Variação de botão full-width */
.btn-primary.full-width {
  width: 100%;
}

/* Variação para botão secundário */
.btn-secondary {
  background-color: transparent;
  border: 2px solid var(--color-primary-white);
  color: var(--color-primary-white);
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Adaptação para dispositivos móveis */
@media (max-width: 768px) {
  .btn-primary {
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/form/button.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;;EAEnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;;EAE/B,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;;EAErB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB,EAAE,4CAA4C;AACnE;;AAEA,wBAAwB;AACxB;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Estilos base para botões primários */\n.btn-primary {\n  /* Estrutura de layout flex */\n  display: flex;\n  padding: 14px 20px;\n  justify-content: center;\n  align-items: center;\n  \n  /* Estilo visual */\n  border-radius: 8px;\n  border: 2px solid var(--color-primary-red);\n  color: var(--color-primary-red);\n  \n  /* Tipografia */\n  font-family: ShellMedium, sans-serif;\n  font-weight: 500;\n  text-decoration: none;\n  \n  /* Comportamento */\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n/* Estado hover do botão */\n.btn-primary:hover {\n  background-color: rgba(221, 29, 32, 0.1);\n}\n\n/* Estado ativo do botão */\n.btn-primary.active {\n  background: var(--color-primary-red);\n  color: var(--color-primary-white);\n}\n\n/* Estado ativo hover */\n.btn-primary.active:hover {\n  background: #c41a1d; /* Versão mais escura do vermelho primário */\n}\n\n/* Estado desabilitado */\n.btn-primary:disabled,\n.btn-primary.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  border-color: #999;\n  color: #999;\n}\n\n/* Variação de tamanho: tiny */\n.btn-primary[data-size=\"tiny\"] {\n  font-weight: 500;\n  font-size: 12px;\n  letter-spacing: var(--letter-spacing-disclaimer);\n  height: 24px;\n  padding: 0px 8px;\n  vertical-align: bottom;\n}\n\n/* Variação de tamanho: small */\n.btn-primary[data-size=\"small\"] {\n  font-size: 14px;\n  padding: 8px 16px;\n}\n\n/* Variação de tamanho: medium (padrão) */\n.btn-primary[data-size=\"medium\"] {\n  font-size: 16px;\n  padding: 14px 20px;\n}\n\n/* Variação de tamanho: large */\n.btn-primary[data-size=\"large\"] {\n  font-size: 18px;\n  padding: 16px 24px;\n}\n\n/* Variação com ícone */\n.btn-primary.with-icon {\n  gap: 8px;\n}\n\n/* Variação de botão full-width */\n.btn-primary.full-width {\n  width: 100%;\n}\n\n/* Variação para botão secundário */\n.btn-secondary {\n  background-color: transparent;\n  border: 2px solid var(--color-primary-white);\n  color: var(--color-primary-white);\n}\n\n.btn-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Adaptação para dispositivos móveis */\n@media (max-width: 768px) {\n  .btn-primary {\n    padding: 12px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
